import { IAttributes, IController, ISCEService } from 'angular';
export interface IProductButtonsContainerCtrl extends IController {
  productViewItem: any;
  content?: string;
  onChangeColor(): void;
}
export default class ProductButtonsContainerCtrl implements IProductButtonsContainerCtrl {
  productViewItem;
  content?: string;
  private readonly buttonParams: {
    buttonClasses?: string;
    preOrderClasses?: string;
    size?: string;
  };

  /* @ngInject */
  constructor(readonly $sce: ISCEService, readonly $attrs: IAttributes, readonly productViewService) {
    this.buttonParams = {
      buttonClasses: $attrs.buttonClasses,
      preOrderClasses: $attrs.preorderClasses,
      size: $attrs.buttonSize
    };
  }
  $onInit() {
    this.productViewItem.registerChildOnChangeColor(this);
  }
  onChangeColor() {
    this.productViewService.getProductViewButtons(this.productViewItem.productId, this.productViewItem.offer.OfferId, this.buttonParams).then(html => {
      this.content = this.$sce.trustAsHtml(html);
    });
  }
}
ProductButtonsContainerCtrl.$inject = ["$sce", "$attrs", "productViewService"];